import { ref } from 'vue';
import dayjs from "dayjs";
import i18n from "@/i18n/index";
import type { ManipulateType } from 'dayjs';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

// Extend jsPDF with autoTable
(jsPDF as any).API.autoTable = autoTable;
import { start } from '@popperjs/core';
import { useGlobal } from "@/composables/global/useGlobal";



export function usePDF() {
    const { formaDate } = useGlobal();




    return {

    };
}
